import {
	Building2,
	TrendingDown,
	TrendingUp,
	TriangleAlert,
} from "lucide-react";
import type { PortfolioResponse } from "@/adapters/api";
import { Skeleton } from "@/components/ui/skeleton.tsx";
import {
	formatCount,
	formatPercent,
	formatPointsValue,
} from "../../utils/format.ts";
import { KpiCard } from "../kpi-row/index.tsx";

const KPI_SKELETONS = ["obras", "atrasadas", "previsto", "realizado"];

export interface PortfolioKpisProps {
	data?: PortfolioResponse;
	isPending: boolean;
	isError: boolean;
}

export function PortfolioKpis({
	data,
	isPending,
	isError,
}: PortfolioKpisProps) {
	if (isPending) {
		return (
			<div className="kpi-row">
				{KPI_SKELETONS.map((key) => (
					<Skeleton key={key} className="kpi-card-skeleton" />
				))}
			</div>
		);
	}

	if (isError || !data) {
		return (
			<p className="dashboard-panel-error" role="status">
				Não foi possível carregar os indicadores do canteiro.
			</p>
		);
	}

	const deviation = data.actual_percent - data.planned_percent;
	const behind = deviation < 0;

	return (
		<div className="kpi-row">
			<KpiCard
				icon={Building2}
				label="Obras no canteiro"
				value={formatCount(data.constructions)}
				sub={
					data.constructions === 1
						? "Uma obra ativa"
						: "Obras ativas no período"
				}
			/>
			<KpiCard
				icon={TriangleAlert}
				label="Obras com atraso"
				value={formatCount(data.delayed_count)}
				sub={
					data.delayed_count === 0
						? "Nenhuma obra atrasada"
						: "Com ao menos uma etapa atrasada"
				}
				tone={data.delayed_count > 0 ? "warning" : "neutral"}
			/>
			<KpiCard
				icon={TrendingUp}
				label="Realizado do canteiro"
				value={formatPercent(data.actual_percent)}
				sub={`Planejado: ${formatPercent(data.planned_percent)}`}
			/>
			<KpiCard
				icon={behind ? TrendingDown : TrendingUp}
				label="Desvio do canteiro"
				value={formatPointsValue(deviation)}
				unit="p.p."
				sub={behind ? "Abaixo do planejado" : "No prazo ou adiantada"}
				tone={behind ? "negative" : "positive"}
			/>
		</div>
	);
}
